/**
 * Range value parsing and selection state machine.
 */

export function parseRangeValue(value, fallback = new Date()) {
  const GDT = window.GenericDateTime;
  let start = null;
  let end = null;

  if (Array.isArray(value)) {
    start = value[0] != null ? GDT.from(value[0]).toDate() : null;
    end = value[1] != null ? GDT.from(value[1]).toDate() : null;
  } else if (value && typeof value === 'object' && !(value instanceof Date)) {
    start = value.start != null ? GDT.from(value.start).toDate() : null;
    end = value.end != null ? GDT.from(value.end).toDate() : null;
  } else if (value != null) {
    start = GDT.from(value).toDate();
  }

  if (start && end && GDT.from(end).isBefore(GDT.from(start), 'day')) {
    const swapped = start;
    start = end;
    end = swapped;
  }

  const currentDate = end || start || fallback;
  const rangeStep = start && !end ? 'end' : 'start';
  return { currentDate, startDate: start, endDate: end, rangeStep };
}

export function getRangePayload(picker) {
  return { start: picker.state.startDate, end: picker.state.endDate };
}

export function resolveInitialState(config) {
  const GDT = window.GenericDateTime;
  const fallback = GDT?.now?.().toDate?.() ?? new Date();

  if (!config.range) {
    if (config.value === null) {
      return { currentDate: null, startDate: null, endDate: null, rangeStep: 'start' };
    }
    const raw = config.value ?? fallback;
    const currentDate = GDT.from(raw instanceof Date ? raw : new Date(raw)).toDate();
    return { currentDate, startDate: null, endDate: null, rangeStep: 'start' };
  }

  return parseRangeValue(config.value, fallback);
}

/**
 * Apply a range day pick onto picker state. Caller handles hide/update after return.
 * @returns {'partial'|'complete'}
 */
export function selectRangeDate(picker, date) {
  const GDT = window.GenericDateTime;
  const picked = GDT.from(date).startOf('day').toDate();
  const restarting = picker.state.rangeStep === 'start' || (picker.state.startDate && picker.state.endDate);

  if (restarting) {
    picker.state.startDate = picked;
    picker.state.endDate = null;
    picker.state.rangeStep = 'end';
    picker.state.currentDate = picked;
    picker.state.hoverDate = null;
    return 'partial';
  }

  let start = picker.state.startDate;
  let end = picked;
  if (GDT.from(end).isBefore(GDT.from(start), 'day')) {
    const swap = start;
    start = end;
    end = swap;
  }

  picker.state.startDate = start;
  picker.state.endDate = end;
  picker.state.rangeStep = 'start';
  picker.state.currentDate = end;
  picker.state.hoverDate = null;
  return 'complete';
}
